import { render } from "./componentDate.vue?vue&type=template&id=2876ef0a"
import script from "./componentDate.vue?vue&type=script&lang=js"
export * from "./componentDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__